export default __webpack_public_path__ + "static/media/Back_Chevron.fb653f1c.svg";